/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { SoftwareImpactSeverity, SoftwareQuality } from '~shared/types/clean-code-taxonomy';
import { IssueSeverity, IssueType } from '~sq-server-commons/types/issues';

export type SandboxSettingsSoftwareQualities = Array<{
  impactSeverities: Array<SoftwareImpactSeverity>;
  softwareQuality: SoftwareQuality;
}>;

export type SandboxSettingsIssueTypes = Array<{
  severities: Array<IssueSeverity>;
  type: IssueType;
}>;

type SandboxSettingsBaseMQR = {
  enabled: boolean;
  softwareQualities: SandboxSettingsSoftwareQualities;
  types: null;
};

type SandboxSettingsBaseStandard = {
  enabled: boolean;
  softwareQualities: null;
  types: SandboxSettingsIssueTypes;
};
export type SandboxSettingsBase = SandboxSettingsBaseMQR | SandboxSettingsBaseStandard;
export type SandboxInstanceSettings = SandboxSettingsBase & {
  allowOverride: boolean;
  defaultValue: boolean;
};

export type SandboxProjectSettings = SandboxSettingsBase & {
  overridden: boolean;
};

// Form state
export enum SandboxSettingValidationState {
  None = 'none',
  Invalid = 'invalid',
}

export type SandboxSettingsFormState = {
  allowOverride: boolean;
  defaultValue: boolean | null;
  enabled: boolean;
  softwareQualities: SandboxSettingsSoftwareQualities;
  types: SandboxSettingsIssueTypes;
};

export type SandboxSettingsValidationState = {
  allowOverride: SandboxSettingValidationState;
  defaultValue: SandboxSettingValidationState;
  enabled: SandboxSettingValidationState;
  softwareQualities: SandboxSettingValidationState;
  types: SandboxSettingValidationState;
};
